import LinearProgressWithLabel from '@components/LinearProgressWithLabel'
import { BIO_DEV_PHASE_ITEMS } from '@modules/search/components/ResultsSection/constants'
import { calcStageProgress } from '@shared/utils'

import { CellInfo } from '../types'

export const PhaseCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
  } = info

  if (!profileData.profileDevPhase && profileData.profileDevPhase !== '') {
    return null
  }

  const value = profileData.profileDevPhase || 'N/A'

  return <LinearProgressWithLabel label={value} value={calcStageProgress(BIO_DEV_PHASE_ITEMS, value)} orientation="column" />
}
